<div class="body">
    <header class="d-print-none">
        <app-navigation-main></app-navigation-main>
    </header>

    <div class="row-inline">
        <router-outlet></router-outlet>
    </div>

    <footer class="d-print-none">
        <app-footer></app-footer>
    </footer>
</div>